var _defs, _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVbSizefitIllustrations16(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 271.3 306.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        stroke: #231f20;\n      }\n\n      .st0, .st1 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .st2 {\n        fill: #f1f2f2;\n      }\n\n      .st1 {\n        stroke: #ed1c24;\n        stroke-dasharray: 1;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st2",
    width: 271.3,
    height: 306.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M77.46,18.28c-6.02,25.95.47,53.11,7.33,80.6,4.39,17.78,8.96,35.66,10.36,53.39,3.97,49.47-32.67,85.55-35,133.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M164.22,18.28c8.63,15.26,18.53,30.1,26.46,45.18,3.03,5.88,6.58,14.37,6.02,20.96-.42,4.99-1.91,9.94-4.15,14.47-.7,1.54-1.49,3.03-2.38,4.48-6.58,10.87-9.44,12.87-9.67,25.75-.19,10.69,3.41,19.56,6.35,29.59,5.83,19.84,6.86,40.28,5.32,60.81-1.26,17.03-8.58,45.98-7.36,63.01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M212.54,142.35s21.54,18.37,9.73,87.95"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVbSizefitIllustrations16);
export default __webpack_public_path__ + "static/media/VB_SIZE&FIT_ILLUSTRATIONS-16.b33e0b54814a690d7487905c2f9b100c.svg";
export { ForwardRef as ReactComponent };